/**
 * Defines how the message handler provided from the native side looks.
 */
export interface NativeHookMessageHandler {
  postMessage(message: string): void
}

export interface MessageHandlers {
  /** Mobile SDK iOS message handler. */
  KlarnaNativeHookMessageHandler?: NativeHookMessageHandler
}

export declare interface Webkit {
  /** All native-side message handlers are declared under this. */
  messageHandlers?: MessageHandlers
}

export interface InternalWindow extends Window {
  /** Exists if running in an iOS web view. */
  webkit?: Webkit

  /** Mobile SDK Android message handler. */
  KlarnaNativeHookMessageHandler?: NativeHookMessageHandler
}

// list of allowed signals
// more here: https://wiki.klarna.net/wiki/Mobile_SDK_-_Message_Bridge_Signals
// eslint-disable-next-line no-shadow
export enum MobileSDKAction {
  HANDSHAKE = 'handshake',
  LOAD_FULLSCREEN_URL = 'fullscreenLoadUrl',
  FULLSCREEN_SHOW = 'fullscreenShow',
  FULLSCREEN_HIDE = 'fullscreenHide',
  OPEN_EXTERNAL_BROWSER = 'openExternalBrowser',
}
export interface MobileSDKMessage<T> {
  action: MobileSDKAction
  data?: T
}

export interface NativeHookMessage {
  action: string
  messageId: string
  receiver: string
  sender: string
  params: Record<string, unknown>
}
